import { EContractActions, ContractActions } from "./../actions/contract.actions";
import { initialContractState, initialContractResetState, IContractState } from "../state/contract.state";

export function contractReducers(
    state = initialContractState,
    action: ContractActions
): IContractState {
    switch (action.type) {
        case EContractActions.SetContracts: {
            return {
                ...state,
                contracts: action.payload
            };
        }
        case EContractActions.SelectContract: {
            return {
                ...state,
                selectedContract: {
                    data: action.contract,
                    lastAPIError: null
                }
            };
        }
        case EContractActions.SelectedContractAPIError: {
            return {
                ...state,
                selectedContract: {
                    ...state.selectedContract,
                    lastAPIError: action.error
                }
            };
        }
        case EContractActions.ClearSelectedContractData: {
            return {
                ...state,
                ...initialContractResetState
            };
        }
        case EContractActions.SetContractDetails: {
            return {
                ...state,
                selectedContractDetails: {
                    data: action.payload,
                    lastAPIError: null
                }
            };
        }
        case EContractActions.ContractDetailsAPIError: {
            return {
                ...state,
                selectedContractDetails: {
                    ...state.selectedContractDetails,
                    lastAPIError: action.error
                }
            };
        }
        case EContractActions.IsSingleContract: {
            return {
                ...state,
                isSingleContract: action.payload
            };
        }
        case EContractActions.SetTotalDiscount: {
            return {
                ...state,
                totalDiscount: action.payload
            };
        }
        case EContractActions.SetPendingContracts: {
            return {
                ...state,
                pendingContracts: action.payload
            };
        }
        case EContractActions.SetPartnerInfo: {
            return {
                ...state,
                partnerInfo: {
                    data: action.payload,
                    lastAPIError: null
                }
            };
        }
        case EContractActions.PartnerInfoAPIError: {
            return {
                ...state,
                partnerInfo: {
                    ...state.partnerInfo,
                    lastAPIError: action.error
                }
            };
        }
        case EContractActions.SetPaymentReference: {
            return {
                ...state,
                paymentReference: action.payload
            };
        }
        case EContractActions.SetPaymentReferenceError: {
            return {
                ...state,
                paymentReferenceError: action.error
            };
        }
        case EContractActions.SetTotalDiscountsByContract: {
            return {
                ...state,
                totalDiscountsByContract: action.payload
            };
        }
        case EContractActions.SetComplementaryInfo: {
            return {
                ...state,
                complementaryInfo: action.payload,
            };
        }
        case EContractActions.SetUrlToRedirect: {
            return {
                ...state,
                urlToRedirect: action.payload,
            };
        }
        case EContractActions.SetContractFilters: {
            return {
                ...state,
                filters: action.payload,
            };
        }
        case EContractActions.SetCheckupCards: {
            return {
                ...state,
                checkUpCards: action.payload
            };
        }
        case EContractActions.SetBusinessAgrements: {
            return {
                ...state,
                businessAgrements: action.payload
            };
        }
        case EContractActions.UpdateBusinessAgrementsStatus: {
            return {
                ...state,
                updateBusinessAgrementsStatus: action.status
            };
        }
        case EContractActions.SetAddressList: {
            return {
                ...state,
                addressList: action.payload
            };
        }
        case EContractActions.SetTariffsMappings: {
            return {
                ...state,
                tariffsMapping: action.payload
            };
        }
        case EContractActions.SetNewContractTariffs: {
            return {
                ...state,
                newTariffs: action.payload
            };
        }
        case EContractActions.SetPacks: {
            return {
                ...state,
                packs: action.payload
            };
        }
        case EContractActions.SetPack: {
            return {
                ...state,
                selectedPack: action.payload
            };
        }
        case EContractActions.SetDiscounts: {
            return {
                ...state,
                discounts: action.payload
            };
        }
        case EContractActions.SetAlerts: {
            return {
                ...state,
                alerts: action.payload
            };
        }
        case EContractActions.SetContractedServices: {
            return {
                ...state,
                contractedServices: action.payload
            };
        }
        case EContractActions.SetWallBoxService: {
            return {
                ...state,
                wallboxService: action.payload
            };
        }
        default:
            return state;
    }
}
